import React from "react";
import "./index.scss";

const BurgerMenuIcon = (props) => {
  let class_name = props.className ? props.className : '';
  let is_active = props.active ? 'is-active': '';
  return (
    <button
      type="button"
      className={`burger-menu-icon ${is_active} ${class_name}`}
      style={props.style}
      onClick={props.onClick}
    >
      <div className="burger-box">
        <div className="burger-inner"></div>
      </div>
    </button>
  )
};

export default BurgerMenuIcon;
